import { ArrowDownwardOutlined } from "@mui/icons-material";
import React, { useState } from "react";

const About = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleContent = () => {
    setIsExpanded(!isExpanded);
  };

  return (
<div className="pb-0 pt-[4rem] md:pt-[8rem]">      <div className="grid grid-cols-1 md:grid-cols-2 sm:grid-cols-1 w-full px-[20px] md:w-[80%] md:px-0 mx-auto gap-[2.5rem] md:gap-[2rem] items-center">
        <div>
          <span className="eyebrow">About me</span>
          <h2 className="text-[28px] md:text-[36px] lg:text-[42px] leading-tight tracking-[-0.025em] mb-[2rem] font-semibold text-white">
            Transforming
            <span className="text-yellow-400"> visions</span>
          </h2>

          <div className="mb-[3rem] flex items-center md:space-x-5">
            <span className="w-[40px] shrink-0 hidden md:block h-[2px] bg-[#55e6a5] self-start mt-[0.9rem]"></span>

            <p className="body-copy md:w-[90%]">
              As a backend developer, I excel in designing robust and scalable
              server-side applications. My expertise in Python, along with other
              backend technologies, allows me to create efficient APIs and
              manage databases effectively. I also have a strong foundation in
              data science and machine learning, which I utilize to build
              intelligent systems that analyze data, recognize patterns, and
              make data-driven predictions.
              {!isExpanded && "..."}
              {isExpanded && (
                <>
                  <br /><br />I am fascinated by the potential of machine learning to
                  solve real-world problems and am continually expanding my
                  knowledge in this domain. My coursework and projects have
                  given me practical experience with algorithms, data
                  processing, and predictive modeling.
                </>
              )}
            </p>
          </div>

          <button
            className="h-[44px] px-[1.25rem] hover:bg-yellow-400 transition-colors duration-150 text-[14px] font-semibold bg-[#55e6a5] text-[#121121] inline-flex items-center gap-2 rounded-md justify-center"
            onClick={toggleContent}
          >
            {isExpanded ? "Show less" : "Read more"}
            <ArrowDownwardOutlined
              fontSize="small"
              className={`transition-transform ${isExpanded ? "rotate-180" : ""}`}
            />
          </button>
        </div>

        <div className="mx-auto md:mx-0 mt-[1rem] lg:mt-0 relative w-[260px] h-[260px] sm:w-[300px] sm:h-[300px] md:h-[340px] md:w-[340px] lg:w-[400px] lg:h-[400px] -translate-x-2 md:translate-x-0">
          <img
            src={require("../../assets/images/side.jpg")}
            alt="Unique Adhikari"
            className="relative z-[11] w-[100%] h-[100%] object-contain"
          />

          <div className="absolute w-[100%] h-[100%] z-[10] bg-[#55e6a5] top-[-1rem] right-[-1rem] md:top-[-2rem] md:right-[-2rem]"></div>
        </div>
      </div>
    </div>
  );
};

export default About;
